import { NgModule } from '@angular/core';
import { CallCostPipe } from './call-cost.pipe';

@NgModule({
   declarations: [CallCostPipe],
   exports: [CallCostPipe],
})
export class CallCostPipeModule {}
